import React, {useState, useMemo} from "react";
import {API_KEY} from "../../default_informations/api_key";

export const Context = React.createContext({});

function MatchesContext({children}) {
    const apiKey = API_KEY;
    const [value, setValue] = useState('');
    const [leagueID, setLeagueID] = useState('all');
    const [showModalMatch, setShowModalMatch] = useState(false);
    const [modalMatch, setModalMatch] = useState(null);
    const [heroesArr, setHeroesArr] = useState([]);

    /*useEffect(() => {
        let checkMatches = setInterval(() => {
        fetch(`https://api.opendota.com/api/proMatches?api_key=${apiKey}`)
            .then(response => response.json())
            .then(result => console.log(result));
        }, 10000);

        return () => {
            clearInterval(checkMatches)
        }
    }, [apiKey]);

    useEffect(() => {
        let arr = [...proMatches];
        let checkMatches = setInterval(() => {
            fetch(`https://api.opendota.com/api/proMatches?api_key=${apiKey}`)
                .then(response => response.json())
                .then(result => {
                    let match_count = 0;
                    let matches_arr = result.filter(item => {
                        if (Boolean(item.dire_team_id) && Boolean(item.radiant_team_id && Boolean(item.dire_name) && Boolean(item.radiant_name)) && (match_count < 20)) {
                            match_count++;
                            return item;
                        }
                        return null;
                    });
                    if (Boolean(arr[0]) && (arr[0].match_id !== matches_arr[0].match_id) ) {
                        console.log(arr[0].match_id);
                        console.log(matches_arr[0].match_id);
                        setProMatches(matches_arr);
                    }
                })
        }, 10000);

        return () => {
            clearInterval(checkMatches)
        }
    }, [proMatches, apiKey]);*/

    useMemo(() => {
        fetch(`https://api.opendota.com/api/heroes?api_key=${apiKey}`)
            .then(response => response.json())
            .then(result => setHeroesArr(result));
    }, [apiKey]);

    function formSearchValue(value) {
        if (Boolean(value)) {
            setValue(value.toLowerCase());
        } else {
            setValue('');
        }
    }

    function showModalInformation(match) {
        setShowModalMatch(true);
        setModalMatch(match);
    }

    function hideModalInformation() {
        setShowModalMatch(false);
        setModalMatch(null);
    }

    function getLeagueID(id) {
        setLeagueID(id);
    }

    return (
        <Context.Provider value={{
            searchValue: formSearchValue,
            searchTeam: value,
            getId: getLeagueID,
            sidebarLeagueID: leagueID,
            showModal: showModalMatch,
            showModalMatchInformation: showModalInformation,
            hideModalMatchInformation: hideModalInformation,
            modalMatchInfo: modalMatch,
            heroesArr: heroesArr
        }}>
            {children}
        </Context.Provider>
    )
}

export default MatchesContext;